import Autocomplete from '@mui/material/Autocomplete';
import React from 'react';
import TextField from '@mui/material/TextField';
import { FormControl } from '@mui/material';
import { useAppSelector } from '../../hooks/useAppSelector';
import { selectCountriesInfo } from '../../../slices/countries/countriesSlice';
import { useTranslation } from 'react-i18next';

interface CountrySelectorProps {
  value: { value: string; title: string };
  setCountry: React.SetStateAction<any>;
  disabled: boolean;
}

const CountrySelector = ({ value, setCountry, disabled }: CountrySelectorProps) => {
  const { t } = useTranslation();
  const countries = useAppSelector(selectCountriesInfo);
  const countriesOptions = [...countries]
    .filter((el) => el.code !== 'GB')
    .map((el) => ({ value: el.name, title: el.name }));
  return (
    <FormControl sx={{ width: '100%' }}>
      <Autocomplete
        id='countrySelectorAutocomplete'
        disabled={disabled}
        openOnFocus={true}
        options={countriesOptions}
        isOptionEqualToValue={(option, value) => option?.title === value?.title}
        getOptionLabel={(option) => option.title}
        value={value}
        onChange={(
          event: React.SyntheticEvent,
          newValue: {
            title: string;
            value: string;
          } | null
        ) => {
          setCountry(newValue);
        }}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              {option.title}
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant='standard'
            required={true}
            disabled={disabled}
            label={t('labels.country')}
          />
        )}
        sx={{ width: '100%' }}
      />
    </FormControl>
  );
};

export default CountrySelector;
